import React, { useState } from "react";

export default function TicTacToe() {
  const [board, setBoard] = useState(Array(9).fill(null));
  const [xIsNext, setXIsNext] = useState(true);

  const checkWinner = (squares) => {
    const lines = [
      [0, 1, 2],
      [3, 4, 5],
      [6, 7, 8],
      [0, 3, 6],
      [1, 4, 7],
      [2, 5, 8],
      [0, 4, 8],
      [2, 4, 6],
    ];
    for (let i = 0; i < lines.length; i++) {
      const [a, b, c] = lines[i];
      if (squares[a] && squares[a] === squares[b] && squares[a] === squares[c])
        return squares[a];
    }
    return null;
  };

  const winner = checkWinner(board);
  const isDraw = !winner && !board.includes(null);

  const handleClick = (i) => {
    if (board[i] || winner) return;
    const newBoard = [...board];
    newBoard[i] = xIsNext ? "X" : "O";
    setBoard(newBoard);
    setXIsNext(!xIsNext);
  };

  return (
    <div className="min-h-screen bg-slate-900 flex flex-col items-center justify-center font-sans">
      <h1 className="text-4xl font-bold text-white mb-8">Tic Tac Toe</h1>
      <div className="bg-slate-800 p-4 rounded-2xl shadow-2xl">
        <div className="grid grid-cols-3 gap-2">
          {board.map((cell, i) => (
            <button
              key={i}
              onClick={() => handleClick(i)}
              className="w-24 h-24 bg-slate-700 hover:bg-slate-600 rounded-xl text-5xl font-black text-white flex items-center justify-center transition"
            >
              <span className={cell === "X" ? "text-blue-400" : "text-red-400"}>
                {cell}
              </span>
            </button>
          ))}
        </div>
      </div>
      <div className="mt-8 text-2xl font-bold text-white h-8">
        {winner
          ? `Winner: ${winner} 🎉`
          : isDraw
            ? "It's a Draw! 🤝"
            : `Next player: ${xIsNext ? "X" : "O"}`}
      </div>
      {(winner || isDraw) && (
        <button
          onClick={() => setBoard(Array(9).fill(null))}
          className="mt-6 px-6 py-2 bg-indigo-600 text-white font-bold rounded-lg hover:bg-indigo-700 transition"
        >
          Play Again
        </button>
      )}
    </div>
  );
}
